import { render, staticRenderFns } from "./UserUpdateDialogAdditionalInfos.vue?vue&type=template&id=3599a770&scoped=true&"
import script from "./UserUpdateDialogAdditionalInfos.vue?vue&type=script&lang=ts&"
export * from "./UserUpdateDialogAdditionalInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3599a770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
